import React, { useState } from 'react'
import './Certificate_Verify.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faDownload } from  '@fortawesome/free-solid-svg-icons'
import {   faFile } from  '@fortawesome/free-solid-svg-icons'
import {   faShareNodes } from  '@fortawesome/free-solid-svg-icons'
import  { saveAs } from 'file-saver';
import { jsPDF } from "jspdf";
import nodata from '../../assets/certificate/nodata.png'
import {
        FacebookShareButton,
        FacebookIcon,
        LinkedinShareButton,
        LinkedinIcon,
        TwitterShareButton,
        TwitterIcon,
        WhatsappShareButton,
        WhatsappIcon
   
  } from "react-share";


const doc = new jsPDF();
function DisplayData(props){

    //Download as Image

    const downloadImage = ()=>{
        const imgurl =props.baseurl+props.output.Certificate[0].image;
        saveAs(imgurl,props.certfcno);
    }
    //pdf generate
    const generatePdf = ()=>{
        const imgurl =props.baseurl+props.output.Certificate[0].image;
        doc.addImage(imgurl, "JPEG", 30, 40, 153, 108);
        doc.save(props.certfcno);
    } 

    const [toggle ,setToggle] =useState(false);
    console.log("props.bodyClick "+props.bodyClick)
    console.log("toggle "+toggle)

    
    if(props.bodyClick != ''  && toggle == true ){
        console.log("From parent switch off toggle as false")
        setToggle(false);
    }
  
    return(
            
       
        <div  className='displayContainer'>  
       
       
           {
            props.output=== " Certificate is Not Verified" ? 
            <div className="outputContainer w-100" >
                <div className="no-result d-sm-flex justify-content-center align-items-center">
                    <img src={nodata} alt="fail"  width="250px" height="250px"/>
                    <div className="error-text ms-2">
                        <h4 style={{color:"#4360A4"}}>Sorry! No result found</h4>
                        <p style={{color:'#C7CCD7'}}>No Number found in system. Please contact team</p>
                    </div>
                </div>
            </div>
                    :
                    <div className='outputContainer'>
                    <div className='success'>
                        <img src = {props.baseurl+props.output.Certificate[0].image} />
                            <div className='btnContainer'>
                               <button className=' btn btn-primary btnd' onClick={()=>{downloadImage()}} ><span className='d-none d-sm-inline me-2'>Download</span><FontAwesomeIcon   className='btndIcon' icon={faDownload} /></button>
                               <button className='btn btn-primary btnd' onClick={()=>{generatePdf()}}><span className='d-none d-sm-inline me-2'>PDF</span><FontAwesomeIcon  className='btndIcon' icon={faFile} /></button>
                               <button className=' btn btn-primary btnd' onClick={()=> setToggle(!toggle) } ><span className='d-none d-sm-inline me-2'>Share</span><FontAwesomeIcon  className='btndIcon' icon={faShareNodes} /></button>
                               {
                                    toggle && (
                                        <div className="social-share">
                                        <ul className='social-icons-items'>
                                            <li> <FacebookShareButton 
                                                url={props.baseurl+props.output.Certificate[0].image}
                                                quote = {"Aspire Certificate"}>
                                                     <FacebookIcon size={32} round={true} />
                                                    </FacebookShareButton>
                                            </li>
                                            <li>
                                            <LinkedinShareButton 
                                                    title="Aspire Certificate" 
                                                    url={props.baseurl+props.output.Certificate[0].image}>
                                                     <LinkedinIcon size={32} round={true} />
                                            </LinkedinShareButton>
                                            </li>
                                            <li>
                                            <TwitterShareButton url={props.baseurl+props.output.Certificate[0].image}>
                                                     <TwitterIcon size={32} round={true} />
                                            </TwitterShareButton>
                                            </li>
                                            <li>
                                            <WhatsappShareButton 
                                                title="Aspire Certificate" 
                                                url={props.baseurl+props.output.Certificate[0].image}>
                                                     <WhatsappIcon size={32} round={true} />
                                            </WhatsappShareButton>
                                            </li>
                                            
                                        </ul>
                                        </div>
                                    )
                                }
                              
                            </div>
                    </div>

                       
                   </div>
           }
        </div>
    )

}
export default DisplayData;